/*
 * Keeps the free-shipping announcement in step with the cart.
 *
 * The cart drawer updates itself for free: Dawn asks the Section Rendering API for a
 * fresh copy of it on every cart change. The announcement bar is not on that list, so
 * this listens for the same cart-update event and asks for the announcement section
 * itself, then copies the new message across.
 *
 * Deliberately no arithmetic here. The threshold, the subtraction and the currency
 * formatting all stay in snippets/announcement-text.liquid; this file only moves the
 * already-rendered sentence into place. One source of truth, and no second money
 * formatter to keep in sync with the first.
 */

(function () {
  const SELECTOR = '[data-free-shipping-announcement]';

  let inFlight = false;
  let queued = false;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refresh() {
    const targets = document.querySelectorAll(SELECTOR);
    if (!targets.length) return;

    // A second cart change while a fetch is open would otherwise be dropped and
    // leave a stale number on screen, so remember it and re-run once we land.
    if (inFlight) {
      queued = true;
      return;
    }
    inFlight = true;

    const sectionId = targets[0].dataset.freeShippingAnnouncement;

    fetch(`${shopRoot()}?section_id=${encodeURIComponent(sectionId)}`)
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelectorAll(SELECTOR);
        if (!fresh.length) return;

        // innerHTML rather than textContent: the message carries a <strong> run.
        // What we are copying is markup this theme just rendered, and the operator's
        // own words were escaped by text-with-emphasis.liquid before that <strong>
        // was added — so there is no untrusted HTML in play here.
        document.querySelectorAll(SELECTOR).forEach((element, index) => {
          const next = fresh[index] || fresh[0];
          if (next && element.innerHTML !== next.innerHTML) {
            element.innerHTML = next.innerHTML;
          }
        });
      })
      .catch(() => {
        // Leave whatever is on screen alone. A message one cart-change out of date
        // is better than a blank bar, and the next page load renders it correctly.
      })
      .finally(() => {
        inFlight = false;
        if (queued) {
          queued = false;
          refresh();
        }
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
})();
